export enum TwoFactorAuthMethodType
{
    AuthenticatorApplication = 0
}